<zah-activiteiten-navigatie [initialPageRequest]="initialPageRequest"
  [activiteitenPage]="activiteitenPage"
  [zones]="zones"
  [diensten]="diensten"
  (activiteitSelected)="openActiviteit($event)"
  (pageChange)="onPageChange($event)">
  <div class="content">
    @if (selectedActiviteit) {
      <zah-activiteit-card
        [activiteit]="selectedActiviteit"
        [client]="activiteitenPage.getClient(selectedActiviteit.getClientId())"
        [auteur]="activiteitenPage.getAuteur(selectedActiviteit.getAuteurId())"
        [zones]="zones"
        (verwerkClicked)="onVerwerkClicked($event)"
        (activiteitCardClicked)="onActiviteitCardClicked($event)">
      </zah-activiteit-card>
    }
    @if (activiteitenPage.isEmpty()) {
      <div>
        Er zijn geen activiteiten.
      </div>
    }
  </div>
</zah-activiteiten-navigatie>
